<template>
  <p>
    <input
      :id="id"
      ref="input"
      v-bind="$attrs"
      :class="[error ? errorClass : '', cClass]"
      :type="type"
      :value="resetInput ? '' : value"
      @input="$emit('input', resetInput ? '' : $event.target.value)"
      @focus="$emit('focus')"
      :required="required"
    />
  </p>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String | Number,
    required: {
      type: Boolean,
      default: false,
    },
    error: String,
    errorClass: {
      type: String,
      default: 'border-red-400',
    },
    cClass: {
      type: String,
      default: '',
    },
    resetInput: Boolean
  },
  watch: {
    // resetInput(val) {
    //   val = !val
    // }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>
